
import Game from "./game";
import Server$ from "./network/net";
import ErrorDriver from "./error";
import Run from "./run";
import Space from "./frp/space";
import Stream from "./frp/stream";

export default function(
    server,
    construct,
    serverOptions,
    rootContainer,
    errorView,
    uiConfig,
    $resize
)
{
    var $tickerSeconds = new Stream( "ticker" );
    var lastTime = Date.now();
    TweenMax.ticker.addEventListener('tick', function(event)  {
        TWEEN.update(performance.now());
        
        var now = Date.now();
        var dt = now - lastTime;
        
        lastTime = now;
        $tickerSeconds.next( dt / 1000 );
    });
    
    const $keyboard = new Stream( "keyboard" );
    window.addEventListener('keydown', event => $keyboard.next( event.which ) );
    
    /*const $handle_resize = new Stream( "handle_resize" )
    const $size = new Stream( "size" )
    $handle_resize
        .map( () => ({ x : window.innerWidth, y : window.innerHeight }) )
        .to( $size )
    window.addEventListener( "resize", () => $handle_resize.next() )*/
    
    window.onkeydown = e => {
        if (e.keyCode === 32 || e.keyCode >= 112 && e.keyCode <= 121 ) { // F1-F10
            return false;
        }
        
        return true;
    };
    
    window.onkeyup = e => {
        if (e.keyCode === 32 || e.keyCode >= 112 && e.keyCode <= 121 ) { // F1-F10
            return false;
        }
        
        return true;
    };
    
    const app = {};
    
    const server$ = Server$( server );
    const errorDriver = ErrorDriver(
        errorView,
        server$,
        serverOptions,
        server.lobbyURL,
        server.$error
    );
    let needReset = true;
    server.$error.subscribe( () => {
        needReset = true;
        rootContainer.interactive = false;
    } );
    server.$net.on( () =>
    {
        if ( ! needReset ) return
        
        needReset = false;
        
        dispose( app );
        
        rootContainer.interactive = true;
        
        console.log( "INIT" );
        
        app.space = new Space( "root" );
        
        app.gameContainer = new PIXI.Container;
        rootContainer.addChild( app.gameContainer );
        rootContainer.addChild( errorView );
        
        app.constructed = construct( server.loginData.spec, app.space );
        
        const run = Run(
            app.gameContainer,
            app.constructed,
            {
                uiConfig,
                spec : server.loginData.spec,
            },
            app.space,
        );
        
        Game(
            app.space,
            run,
            {
                lines : server.loginData.spec.lines_array,
                multipliers : server.loginData.spec.bets_array,
            },
            server.bonusSettings,
            server.loginData.spec
        );
        
        if ( app.constructed.reactive )
        {
            console.log( "Merging library structure with current game ..." );
            app.constructed.reactive( app.space, app.constructed );
            console.log( "... merged." );
        }
        
        console.time( "Apply" );
        
        app.space.apply();
        
        //glue only after the whole game model built to let different parts subscribe BEFORE state comes in:
        app.space.s( "goLobby" ).to( errorDriver.$goLobby );
        app.space.s( "progress_indicator" ).to( errorDriver.$preloader )
        errorDriver.$preloader.to( app.space.s( "progress_indicator_get" ) )
        app.space.s( "request" ).to( server$.$request );
        server$.$pending.to( app.space.s( "pending" ) );
        server$.$lastRequest.to( app.space.s( "lastRequest" ) );
        server.$error.to( app.space.s( "error" ) );
        server$.$net.to( app.space.s( "net" ) );
        app.space.s( "net" ).next( server$.$net.value );
        server.$balancePoll.to( app.space.s( "balance_poll" ) );
        server.$progressive_jackpot.to( app.space.s( "progressive_jackpot" ) )
        app.space.s( "progressive_jackpot" ).next( server.$progressive_jackpot.value )
        
        $tickerSeconds.to( app.space.s( "ticker" ) );
        $keyboard.to( app.space.s( "keyboard" ) );
        
        /*$size.to( app.space.s( "size" ) )
        $handle_resize.next()*/
        $resize.to( app.space.s( "size" ) )
        app.space.s( "size" ).next( $resize.value )
        
        console.timeEnd( "Apply" );
        
        
        console.groupCollapsed( "Docs" )
        app.space.print();
        console.groupEnd()
    } );
    server.$net.next( server.$net.value );
}

function dispose( app )
{
    if ( app.gameContainer )
    {
        for ( const child of app.gameContainer.children )
        {
            if ( child.terminate ) child.terminate();
        }
        app.gameContainer.destroy( { children : true } );
    }
    
    if ( app.space )
    {
        app.space.clear();
    }
    
    if ( app.destroy ) app.destroy()
    
    TWEEN.removeAll();
}





// WEBPACK FOOTER //
// ./src/library/init.es6